import React from 'react';
import {CustomerDetailsStepDataHook} from '../CustomerDetailsStep';

export const CustomerDetailsEmpty = () => {
  return <div data-hook={CustomerDetailsStepDataHook.empty} />;
};
